import React from 'react';
import Head from 'next/head';

const CustomHead = () => {
  return (
    <Head>
      <link rel="preconnect" href="https://sa2m.col.movistar.es" />
      <link
        rel="preconnect"
        href="https://europe-west1-mov-prod10.cloudfunctions.net"
      />
      <link rel="preconnect" href="https://mantix.col.movistar.es" />
      <link rel="preconnect" href="https://webservices.telefonica.es" />
      <link
        rel="preconnect"
        href="https://europe-west1-mov-prod10.cloudfunctions.net"
      />
      <link rel="preconnect" href="https://www.googletagmanager.com" />
      <link rel="preconnect" href="https://customizer.col.movistar.es" />
    </Head>
  );
};

export default CustomHead;
